export default "__VITE_ASSET__BjDaJvk$__"